import React, { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import DashLayout from "../../layouts/DashLayout";
import Overlay from "../../components/Overlay";
import Select from "react-select";
import { style } from "../../styles/Style";
// import {
//   addnewHealthTest,
//   getHealthTests,
// } from "../../store/actions/HtestActions";
import {
  addnewMeeting,
  getMeetings,
} from "../../store/actions/MeetingsActions";
import {
  addnewSaturdayStudy,
  getSaturdayStudies,
} from "../../store/actions/SstudiesActions";
import {
  addnewYearEvent,
  getYearEvents,
} from "../../store/actions/YearEventActions";
import { addnewVisit, getVisits } from "../../store/actions/VisitActions";
import { useDispatch, useSelector } from "react-redux";
import changeFromTimeStamp from "../../utils/ChangeMonthToText";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";

function Events() {
  const dispatch = useDispatch();

  // const healthTestsEvents = useSelector(
  //   (state) => state.healthTestsEventState.healthTests
  // );
  const meetingsEvents = useSelector((state) => state.meetingState.meetings);
  const visitsEvents = useSelector((state) => state.visitState.visits);
  const yearEvents = useSelector((state) => state.yearEventState.yearEvents);
  const satStudyEvents = useSelector(
    (state) => state.saturdayStudiesEventState.saturdayStudies
  );
  const loaders = useSelector((state) => state.loadersState);

  // select options
  const [addEventsOvellay, openAddEventsOvellay] = useState(0);
  function eventsOvellayController() {
    openAddEventsOvellay(!addEventsOvellay);
  }

  const [event, setEvent] = useState({
    id: "",
    name: "",
    startDate: "",
    description: "",
    endDate: "",
    station: "",
    creator: "",
  });

  const eventTypesOptions = [
    // {
    //   value: "HT",
    //   label: "Health Test",
    // },
    {
      value: "SS",
      label: "Saturday study",
    },
    {
      value: "ME",
      label: "Meeting",
    },
    {
      value: "VI",
      label: "Visit",
    },
    {
      value: "FIC",
      label: "Free indeed campaign",
    },
    {
      value: "CC",
      label: "Christmas celebration",
    },
    {
      value: "EC",
      label: "East celebration",
    },
    {
      value: "AC",
      label: "African child",
    },
    {
      value: "OD",
      label: "Open day",
    },
  ];

  // transform schools data
  let loadedEvents = [];
  // for (let i = 0; i < healthTestsEvents.length; i++) {
  //   const event = {
  //     count: i + 1,
  //     id: healthTestsEvents[i].id,
  //     eventType: "HT",
  //     name: healthTestsEvents[i].name,
  //     date: (
  //       <div className="flex flex-col">
  //         <div className="flex-row flex mr-2">
  //           <span className="mr-1">Starts at </span>
  //           <span>{changeFromTimeStamp(healthTestsEvents[i].startDate)}</span>
  //         </div>
  //         <div
  //           className={
  //             healthTestsEvents[i].endDate ? "flex-row flex" : "hidden"
  //           }
  //         >
  //           <span className="mr-1">Ends at </span>
  //           <span> {changeFromTimeStamp(healthTestsEvents[i].endDate)}</span>
  //         </div>
  //       </div>
  //     ),
  //   };

  //   loadedEvents.push(event);
  // }
  // adding meetings
  for (let i = 0; i < meetingsEvents.length; i++) {
    const event = {
      count: i + 1,
      id: meetingsEvents[i].id,
      name: meetingsEvents[i].name,
      eventType: "ME",
      date: (
        <div className="flex flex-col">
          <div className="flex-row flex mr-2">
            <span className="mr-1">Occur date </span>
            <span>{changeFromTimeStamp(meetingsEvents[i].occurAt)}</span>
          </div>
        </div>
      ),
    };

    loadedEvents.push(event);
  }
  // add sat studies

  for (let i = 0; i < satStudyEvents.length; i++) {
    const event = {
      count: i + 1,
      id: satStudyEvents[i].id,
      name: satStudyEvents[i].name,
      eventType: "SS",
      date: (
        <div className="flex flex-col">
          <div className="flex-row flex mr-2">
            <span className="mr-1"> Date </span>
            <span>{changeFromTimeStamp(satStudyEvents[i].date)}</span>
          </div>
        </div>
      ),
    };

    loadedEvents.push(event);
  }

  for (let i = 0; i < yearEvents.length; i++) {
    const event = {
      count: i + 1,
      id: yearEvents[i].id,
      name: yearEvents[i].eventName,
      eventType: "",
      date: (
        <div className="flex flex-col">
          <div className="flex-row flex mr-2">
            <span className="mr-1">Starts at </span>
            <span>{changeFromTimeStamp(yearEvents[i].startTime)}</span>
          </div>
          <div className={yearEvents[i].endTime ? "flex-row flex" : "hidden"}>
            <span className="mr-1">Ends at </span>
            <span> {changeFromTimeStamp(yearEvents[i].endTime)}</span>
          </div>
        </div>
      ),
    };

    loadedEvents.push(event);
  }
  // adding visits
  for (let i = 0; i < visitsEvents.length; i++) {
    const event = {
      count: i + 1,
      id: visitsEvents[i].id,
      name: visitsEvents[i].name,
      eventType: "VI",
      date: (
        <div className="flex flex-col">
          <div className="flex-row flex mr-2">
            <span className="mr-1">Starts at </span>
            <span>{changeFromTimeStamp(visitsEvents[i].startDate)}</span>
          </div>
          <div className={visitsEvents[i].endDate ? "flex-row flex" : "hidden"}>
            <span className="mr-1">Ends at </span>
            <span> {changeFromTimeStamp(visitsEvents[i].endDate)}</span>
          </div>
        </div>
      ),
    };

    loadedEvents.push(event);
  }

  const [selectedEvent, setSelectedEvent] = useState(null);
  // const userId = JSON.parse(
  //   `${useSelector((state) => state.auth.session)}`
  // ).userId;
  // handle event  submit

  // const handleHTsubmit = (e) => {
  //   e.preventDefault();
  //   const healthTest = {
  //     commonPlaceName: event.station,
  //     createdBy: {
  //       idValue: userId,
  //     },
  //     healthTestEventAttendees: [],
  //     description: event.description,
  //     endDate: event.endDate,
  //     name: event.name,
  //     startDate: event.startDate,
  //   };
  //   dispatch(addnewHealthTest(healthTest, closeEventFormAfterAdding));

  // };

  const handleSTsubmit = (e) => {
    e.preventDefault();
    const saturdayStudy = {
      place: event.station,
      name: event.name,
      date: event.startDate,
    };
    dispatch(addnewSaturdayStudy(saturdayStudy, closeEventFormAfterAdding));
  };

  const handleMeetingsubmit = (e) => {
    e.preventDefault();
    const meeting = {
      place: event.station,
      purposeOfMeeting: event.description,
      name: event.name,
      occurAt: event.startDate,
    };
    dispatch(addnewMeeting(meeting, closeEventFormAfterAdding));
  };

  const handleVisitsubmit = (e) => {
    e.preventDefault();
    const visit = {
      endDate: event.endDate,
      name: event.name,
      startDate: event.startDate,
    };
    dispatch(addnewVisit(visit, closeEventFormAfterAdding));
  };

  const handleYearEventsubmit = (e) => {
    e.preventDefault();
    const yearEvent = {
      endDate: event.endDate,
      eventName: event.name,
      startTime: event.startDate,
      endTime: event.endDate,
      budget: event.budget,
      comments: event.description,
      location: event.station,
    };
    dispatch(addnewYearEvent(yearEvent, closeEventFormAfterAdding));
  };

  useEffect(() => {
    dispatch(getMeetings());
    dispatch(getVisits());
    // dispatch(getHealthTests());
    dispatch(getSaturdayStudies());
    dispatch(getYearEvents());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function closeEventFormAfterAdding() {
    eventsOvellayController();
    setEvent({
      id: "",
      name: "",
      startDate: "",
      description: "",
      endDate: "",
      station: "",
      creator: "",
    });
  }
  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      <div className="mx-10 bg-white rounded">
        <div className="flex p-10 pl-10 pb-0">
          <h2 className="font-semibold">Registered events</h2>
          <div className="m-auto mr-0">
            <button
              className="p-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
              onClick={() => {
                eventsOvellayController();
              }}
            >
              <FiEdit />
            </button>
          </div>
        </div>
        <div className="border-b pb-5 mx-10 border-gray-100" />
        <div className="flex flex-row flex-wrap pl-10 py-5 pr-10">
          {!loaders.visit.fetchingLoaders |
          !loaders.meeting.fetchingLoaders |
          !loaders.satStudy.fetchingLoaders ? (
            !loaders.visit.fetchingLoaders &
              !loaders.meeting.fetchingLoaders &
              !loaders.satStudy.fetchingLoaders && loadedEvents.length < 1 ? (
              <div
                className={
                  "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                }
              >
                <p>{"No events found"}</p>
              </div>
            ) : (
              loadedEvents?.map((Events, i) => {
                return (
                  <Link
                    className="w-full md:w-1/2 lg:w-1/3 cursor-default px-2"
                    to={
                      `${
                        Events.eventType === "VI"
                          ? "/services/events/visits/"
                          : Events.eventType === "SS"
                          ? "/services/events/saturday/"
                          : Events.eventType === "ME"
                          ? "/services/events/meeting/"
                          : "/services/events/annualevent/"
                      }` + Events.id
                    }
                    key={i}
                  >
                    <div className="flex flex-col h-24 bg-gray-50 py-4 border-l-4 my-2 mr-4 border rounded rounded-l-none border-indigo-100  cursor-pointer  hover:bg-gray-100">
                      <div className="font-semibold fit-content">
                        <div className="flex">
                          <span className="mx-3 m-auto">{Events.name}</span>
                        </div>
                      </div>
                      <div className="my-auto mx-3">{Events.date}</div>
                      <div className="m-auto mx-3 mr-5 text-indigo-500  border border-indigo-100 bg-indigo-100 px-2 rounded fit-content">
                        {Events.eventType === "VI"
                          ? "Visit"
                          : Events.eventType === "SS"
                          ? "Saturday Study"
                          : Events.eventType === "ME"
                          ? "Meeting"
                          : "Annual event"}
                      </div>
                    </div>
                  </Link>
                );
              })
            )
          ) : (
            <div className="spinner m-auto indigo-spinner">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          )}
        </div>
        {/*add Events overlay  */}
        <div className={addEventsOvellay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.visit.message & (selectedEvent === "VI")
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.visit.message}</p>
              </div>
              <div
                className={
                  loaders.healthTest.message & (selectedEvent === "HT")
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.healthTest.message}</p>
              </div>
              <div
                className={
                  loaders.meeting.message & (selectedEvent === "ME")
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.meeting.message}</p>
              </div>
              <div
                className={
                  loaders.satStudy.message & (selectedEvent === "SS")
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.satStudy.message}</p>
              </div>
              <div
                className={
                  (loaders.yearEvent.message & (selectedEvent === "FIC")) |
                  (selectedEvent === "CC") |
                  (selectedEvent === "EC") |
                  (selectedEvent === "AC") |
                  (selectedEvent === "OD")
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.yearEvent.message}</p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">{"Register event"}</h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        return eventsOvellayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <form
                      className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2"
                      onSubmit={
                        selectedEvent === "VI"
                          ? handleVisitsubmit
                          : selectedEvent === "SS"
                          ? handleSTsubmit
                          : selectedEvent === "ME"
                          ? handleMeetingsubmit
                          : handleYearEventsubmit
                      }
                    >
                      <div>
                        <div className="flex flex-col pt-3">
                          {/*  field */}
                          <div className="py-2  w-full">
                            <label>Event type </label>
                            <Select
                              options={eventTypesOptions}
                              onChange={(e) => setSelectedEvent(e.value)}
                            />
                          </div>
                          {/*  field */}
                          <div className="py-2 w-full">
                            <label>Name </label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="text"
                                className={style.field.input}
                                value={event.name}
                                onChange={(e) =>
                                  setEvent({
                                    ...event,
                                    name: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="py-2 w-full">
                            <label>
                              {(selectedEvent === "ME") |
                              (selectedEvent === "SS")
                                ? "Occur date"
                                : "Starts at"}{" "}
                            </label>
                            <div className={style.field.parentDiv}>
                              <input
                                type={
                                  (selectedEvent === "ME") |
                                  (selectedEvent === "FIC") |
                                  (selectedEvent === "CC") |
                                  (selectedEvent === "EC") |
                                  (selectedEvent === "AC") |
                                  (selectedEvent === "OD") |
                                  (selectedEvent === "SS")
                                    ? "datetime-local"
                                    : "date"
                                }
                                className={style.field.input}
                                value={event.startDate}
                                onChange={(e) =>
                                  setEvent({
                                    ...event,
                                    startDate: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div
                            className={
                              (selectedEvent === "HT") |
                              (selectedEvent === "VI") |
                              (selectedEvent === "FIC") |
                              (selectedEvent === "CC") |
                              (selectedEvent === "EC") |
                              (selectedEvent === "AC") |
                              (selectedEvent === "OD")
                                ? "py-2 w-full"
                                : "hidden"
                            }
                          >
                            <label>Ends at </label>
                            <div className={style.field.parentDiv}>
                              <input
                                type={
                                  (selectedEvent === "FIC") |
                                  (selectedEvent === "CC") |
                                  (selectedEvent === "EC") |
                                  (selectedEvent === "AC") |
                                  (selectedEvent === "OD")
                                    ? "datetime-local"
                                    : "date"
                                }
                                className={style.field.input}
                                value={event.endDate}
                                onChange={(e) =>
                                  setEvent({
                                    ...event,
                                    endDate: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div
                            className={
                              selectedEvent === "VI" ? "hidden" : "py-2 w-full"
                            }
                          >
                            <label>Event station </label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="text"
                                className={style.field.input}
                                placeholder="eg.RW0622 project office"
                                value={event.station}
                                onChange={(e) =>
                                  setEvent({
                                    ...event,
                                    station: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div
                            className={
                              (selectedEvent === "FIC") |
                              (selectedEvent === "CC") |
                              (selectedEvent === "EC") |
                              (selectedEvent === "AC") |
                              (selectedEvent === "OD") |
                              (selectedEvent === "SS")
                                ? "hidden"
                                : "py-2 w-full"
                            }
                          >
                            <label>Budget</label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="text"
                                className={style.field.input}
                                value={event.budget}
                                onChange={(e) =>
                                  setEvent({
                                    ...event,
                                    budget: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          {/*  field */}
                          <div
                            className={
                              (selectedEvent === "SS") |
                              (selectedEvent === "VI")
                                ? "hidden"
                                : "py-2 w-full"
                            }
                          >
                            <label>
                              {(selectedEvent === "FIC") |
                              (selectedEvent === "CC") |
                              (selectedEvent === "EC") |
                              (selectedEvent === "AC") |
                              (selectedEvent === "OD") |
                              (selectedEvent === "SS")
                                ? "Comment on event"
                                : "Purpose of event"}{" "}
                            </label>
                            <div className={style.field.parentDiv}>
                              <textarea
                                className={style.field.input}
                                value={event.description}
                                onChange={(e) =>
                                  setEvent({
                                    ...event,
                                    description: e.target.value,
                                  })
                                }
                              ></textarea>
                            </div>
                          </div>

                          {/* save btn */}
                          <button
                            type="submit"
                            className={style.loginBtn}
                            disabled={
                              loaders.visit.sendingLoader |
                              loaders.satStudy.sendingLoader |
                              loaders.healthTest.sendingLoader |
                              loaders.meeting.sendingLoader |
                              loaders.yearEvent.sendingLoader
                            }
                          >
                            {!loaders.visit.sendingLoader |
                            !loaders.satStudy.sendingLoader |
                            !loaders.meeting.sendingLoader |
                            !loaders.healthTest.sendingLoader |
                            !loaders.yearEvent.sendingLoader ? (
                              <p className="m-auto">{"Register"}</p>
                            ) : (
                              <div className="spinner m-auto">
                                <div className="bounce1"></div>
                                <div className="bounce2"></div>
                                <div className="bounce3"></div>
                              </div>
                            )}{" "}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>
      </div>
    </DashLayout>
  );
}

export default Events;
